import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import {
  ArrowPathIcon,
  MagnifyingGlassIcon,
} from "@heroicons/react/24/outline";
import MessageAlert from "../sharedComponents/messageAlert";
import useLanguageDirection from "../../hooks/useLanguageDirection";
import { searchBrand, clearBrands } from "../../redux/reducer/brandReducer";
import CustomCategoryCardsWithCategory from "./customCategoryCardsWithCategory";

const TYPE_IDS = {
  turkey: "67dfef4a100f542a2c700c04",
  europe: "67dfef98100f542a2c700c08",
};

const SearchBrands = () => {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const direction = useLanguageDirection();

  const [search, setsearch] = useState("");
  const [activeTab, setActiveTab] = useState("turkey");
  const [isLoading, setIsLoading] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [message, setMessage] = useState(null);
  const [messageType, setMessageType] = useState(null);
  const { allBrands, loading, error } = useSelector((state) => state.brands);
  useEffect(() => {
    return () => {
      dispatch(clearBrands());
    };
  }, [dispatch]);
  useEffect(() => {
    if (message) {
      const timer = setTimeout(() => setMessage(null), 2000);
      return () => clearTimeout(timer);
    }
  }, [message]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!search.trim()) {
      setMessageType("error");
      setMessage(t("noSearchResults"));
      return;
    }

    if (!search) {
      setMessageType("error");
      setMessage(t("noSearchResults"));
    }

    const payload = {
      id: TYPE_IDS[activeTab],
      keyword: search,
    };

    try {
      setIsLoading(true);
      setIsDisabled(true);
      await dispatch(searchBrand(payload)).unwrap();
      // setsearch("");
    } catch (err) {
      setMessageType("error");
      setMessage(t("noSearchResults"));
    } finally {
      setIsLoading(false);
      setIsDisabled(false);
    }
  };
  // console.log(allBrands);
  return (
    <div className="relative flex flex-col items-center w-full">
      {/* Tabs */}
      <div className="flex gap-3 mb-4">
        <button
          type="button"
          onClick={() => {
            setActiveTab("turkey");
            dispatch(clearBrands());
            // setsearch("");
          }}
          className={`px-5 py-2 border text-sm ${
            activeTab === "turkey"
              ? "bg-black text-white"
              : "bg-transparent text-black"
          }`}
        >
          {t("searchTurkeyBrands")}
        </button>

        <button
          type="button"
          // onClick={() => setActiveTab("europe")}
          onClick={() => {
            setActiveTab("europe");
            dispatch(clearBrands());
            // setsearch("");
          }}
          className={`px-5 py-2 border md:text-base text-sm ${
            activeTab === "europe"
              ? "bg-black text-white"
              : "bg-transparent text-black"
          }`}
        >
          {t("searchEuropaBrands")}
        </button>
      </div>

      {/* Form */}
      <form className="w-full" onSubmit={handleSubmit}>
        {message && <MessageAlert type={messageType} message={message} />}

        <div className="relative w-full">
          <input
            type="text"
            placeholder={
              activeTab === "turkey"
                ? t("searchTurkeyBrands")
                : t("searchEuropaBrands")
            }
            dir={i18n.language === "ar" ? "rtl" : "ltr"}
            className={`w-full p-3 text-gray-700 bg-white border shadow-sm lg:py-4 lg:placeholder:text-lg focus:ring focus:ring-yellow-400 focus:outline-none ${
              i18n.language === "ar" ? "pr-2" : "pl-2"
            }`}
            value={search}
            onChange={(e) => setsearch(e.target.value)}
          />

          <button
            type="submit"
            disabled={isDisabled || isLoading}
            className={`absolute top-1/2 -translate-y-1/2 end-2 px-4 py-2 ${
              isDisabled
                ? "bg-yellow-500 cursor-not-allowed"
                : "bg-custom-yellow"
            }`}
            dir={direction}
          >
            {isLoading ? (
              <ArrowPathIcon className="w-6 h-6 text-white bg-yellow-500 rounded-full animate-spin" />
            ) : (
              <>
                <MagnifyingGlassIcon className="inline w-5 h-5 me-2" />
                {t("search")}
              </>
            )}
          </button>
        </div>
      </form>
      <section className="grid md:grid-cols-3 grid-cols-2 gap-2 md:gap-4 max-h-[50vh] overflow-y-scroll overflow-auto  w-full mt-4">
        {allBrands?.map((item, index) => (
          <div key={`${item._id}`}>
            {/* <div className="flex-shrink-0 min-w-[140px] max-w-[140px] lg:min-w-[185px] lg:max-w-[185px] group"> */}
            <div className="flex-shrink-0 min-w-[90%] max-w-[90%] lg:min-w-[185px] lg:max-w-[185px] group">
              <CustomCategoryCardsWithCategory
                image={item?.img}
                title={item?.title}
                category={
                  direction === "rtl"
                    ? item?.category?.title?.ar
                    : item?.category?.title?.en
                }
                subCategory={
                  direction === "rtl"
                    ? item?.subCategory?.name?.ar
                    : item?.subCategory?.name?.en
                }
                SubCategory
                link={item?.link}
              />
            </div>
          </div>
        ))}
      </section>
    </div>
  );
};

export default SearchBrands;
